var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "136pt",
    viewBox: "-1 0 136 136.21852",
    width: "136pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m93.148438 80.832031c16.351562-23.089843 10.882812-55.0625-12.207032-71.410156s-55.0625-10.882813-71.410156 12.210937c-16.347656 23.089844-10.882812 55.058594 12.210938 71.40625 16.480468 11.667969 38.269531 12.566407 55.652343 2.300782l37.769531 37.542968c4.078126 4.292969 10.863282 4.464844 15.15625.386719 4.292969-4.074219 4.464844-10.859375.390626-15.152343-.128907-.136719-.253907-.261719-.390626-.390626zm-41.839844 3.5c-18.246094.003907-33.039063-14.777343-33.050782-33.023437-.003906-18.246094 14.777344-33.039063 33.027344-33.046875 18.222656-.007813 33.007813 14.75 33.042969 32.972656.03125 18.25-14.742187 33.066406-32.996094 33.097656-.007812 0-.011719 0-.023437 0zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.eae18e3b53df46a60a977c2105b191b2.svg";
export { ForwardRef as ReactComponent };